











































import { Action, Mutation, State, Getter } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
import {
  GET_REGISTER_SYSTEM_FORM_VISIBILITY,
  UPDATE_REGISTER_FORM_VISIBILITY,
  GET_SELECTED_SYSTEM,
  UPDATE_SELECTED_SYSTEM,
  FETCH_SYSTEM_LIST,
  CREATE_SYSTEM_LIST,
  CREATE_NEW_SYSTEM,
  UPDATE_SYSTEM_LIST,
  UPDATE_SYSTEM,
} from '@/modules/system/store';
import { ISystem } from '@/modules/system/models';
import { MessageService } from '@/services/messageService';

@Component({
  components: {},
})
export default class extends Vue {
  public saving: boolean = false;
  public valid: boolean = false;
  public nome: string = '';
  public state: any = {};
  public newSystem: ISystem = {
    id: 0,
    systemname: '',
    isactive: true,
  };

  public nameRules: any[] = [
    (v: any) => !!v || 'Nome é obrigatório',
    (v: any) =>
      (v && v.length <= 255) || 'Nome precisa ter menos que 255 caracteres',
  ];

  @Getter(GET_SELECTED_SYSTEM) // Recupera o sistema selecionado
  public systemSelected: ISystem;

  @Getter(GET_REGISTER_SYSTEM_FORM_VISIBILITY) // Recupera flag de exibição do formulário.
  public showSystemForm: boolean;

  @Action(CREATE_NEW_SYSTEM) // Cria o sistema no banco.
  public createSystem: any;

  @Action(UPDATE_SYSTEM_LIST) // Atualiza a lista de sistemas.
  public updateSystems: any;

  @Action(UPDATE_REGISTER_FORM_VISIBILITY) // Atualiza a flag de exibição do formulário
  private setShowRegisterForm: any;

  @Action(UPDATE_SELECTED_SYSTEM) // Seta o sistema atual selecionado.
  private setSelectedSystem: any;

  @Action(UPDATE_SYSTEM) // Atualiza o sistema no banco.
  private updateSystem: any;

  @Action(FETCH_SYSTEM_LIST) // Recupera a lista de sistemas do banco.
  private getAllSystems: any;

  @Action(CREATE_SYSTEM_LIST)
  private setAllSystems: any;

  public cancelEdit() {
    this.setSelectedSystem(this.newSystem);

    this.getAllSystems().then((ret: any) => {
      this.setAllSystems(ret.data);
      this.setShowRegisterForm(!this.showSystemForm);
    });
  }

  public saveSystem() {
    if (this.systemSelected.id === 0) {
      this.addSystem();
    } else {
      this.update();
    }
  }

  private addSystem() {
    this.saving = true;
    this.createSystem(this.systemSelected).then((ret: any) => {
      MessageService.Success('Sucesso', 'Operação realizada com sucesso.');
      this.cancelEdit();
    }).finally(() => (this.saving = false));
  }

  private update() {
    this.saving = true;
    this.updateSystem(this.systemSelected).then(() => {
      this.resetParameters();
    }).finally(() => (this.saving = false));
  }

  private resetParameters() {
    MessageService.Success('Sucesso', 'Operação realizada com sucesso.');

    this.setSelectedSystem(this.newSystem);
    this.setShowRegisterForm(!this.showSystemForm);
  }
}
